/**
 * sample tabListWithTitleObj = {
 *     title: {
 *         icon: "",
 *         titleTextInBold: "",
 *         titleText: "",
 *      },
 *      tabBodyComponent: <p>Tabbed Body Component 1</p>,
 *      linkTo: "/tab1"
 * }
 */
import React from 'react';
import Icons from '../icons/Icons';
import TabbedNavigation from './TabbedNavigation';
import styles from './TabbedNavigation.styles';

export default function TabbedNavigationWithDefinedTitle({ tabListWithTitleObj = [], useSeparateUrl = false, sectionPath, activeTabIndex, onChangeTabCb, unMountChildComponentOnSwitch = false, }) {

    const tabList = tabListWithTitleObj.map((item, idx) => {
        return(
            {
                ...item,
                title: titleElementJSX(item, idx),
            }
        )
    });

    return (
        <TabbedNavigation tabList={tabList} useSeparateUrl={useSeparateUrl} parentPath={sectionPath} activeTabIndex={activeTabIndex} onChangeTabCb={onChangeTabCb} unMountChildComponentOnSwitch={unMountChildComponentOnSwitch} />
    )
}

function titleElementJSX(item, idx) {
    if (item?.title?.titleText) {
        return <span key={idx} style={styles.titleContainer}>
            {(item.title.icon) ? <span style={styles.titleIcon}><Icons familyName='vec' iconName={item.title.icon} /></span> : ""}
            {(item.title?.titleTextInBold) ? <span style={styles.titleInBold}>{item.title.titleTextInBold}</span> : ""}
            <span>{item.title.titleText}</span>
        </span>
    } else {
        return null
    }
}